import { all } from 'redux-saga/effects';
import { getUserPhotoSaga } from './user-photo.action';

export { getUserPhoto } from './user-photo.action';
export { default as userPhotoReducer } from './user-photo.reducer';

export const userPhotoSaga = function* () {
  yield all([getUserPhotoSaga()]);
};
